import React from "react";
import { Link } from "react-router-dom";
import * as Icons from "lucide-react";
import { ArrowUpRight } from "lucide-react";
import Reveal from "../components/Reveal";
import { useSite } from "../context/SiteContext";

const Icon = ({ name, ...props }) => {
    const Cmp = Icons[name] || Icons.BookOpen;
    return <Cmp {...props} />;
};

export const Courses = ({ standalone = false }) => {
    const { content } = useSite();
    const list = content.courses || [];

    return (
        <section
            id="courses"
            data-testid="courses-section"
            className={`relative bg-[#FAFAFA] ${standalone ? "pt-36 pb-28" : "py-24 lg:py-32"}`}
        >
            <div className="max-w-7xl mx-auto px-5 lg:px-10">
                <div className="grid lg:grid-cols-12 gap-10 mb-14">
                    <Reveal className="lg:col-span-7">
                        <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-[#14545E]/10 text-[#14545E] text-[11px] tracking-[0.2em] uppercase mb-5">
                            Kurslarımız
                        </div>
                        <h2 className="font-serif-display text-4xl sm:text-5xl lg:text-6xl text-[#0A1F3D] leading-[1.05]">
                            Hər şagird üçün bir <span className="text-[#14545E]">yol.</span>
                        </h2>
                    </Reveal>
                    <Reveal delay={0.15} className="lg:col-span-5 flex items-end">
                        <p className="text-neutral-600 text-base lg:text-lg leading-relaxed">
                            Akademiyamız hər yaş və səviyyədə şagirdlər üçün hərtərəfli proqramlar təklif edir — buraxılış imtahanlarından beynəlxalq sertifikat hazırlığına qədər.
                        </p>
                    </Reveal>
                </div>

                <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4 lg:gap-5">
                    {list.map((s, i) => (
                        <Reveal key={s.id || i} delay={i * 0.05}>
                            <div
                                data-testid={`course-card-${i}`}
                                className="group relative bg-white border border-neutral-200 hover:border-[#14545E] rounded-2xl p-7 h-full flex flex-col gap-5 transition-all duration-500 hover:shadow-xl hover:shadow-[#14545E]/10 hover:-translate-y-1"
                            >
                                <div className="flex items-center justify-between">
                                    <div className="h-12 w-12 rounded-xl bg-[#14545E]/10 text-[#14545E] flex items-center justify-center group-hover:bg-[#14545E] group-hover:text-white transition-colors">
                                        <Icon name={s.icon} size={20} />
                                    </div>
                                    <span className="text-[10px] tracking-[0.2em] text-neutral-400 uppercase">
                                        {s.level || `0${i + 1}`}
                                    </span>
                                </div>
                                <h3 className="font-serif-display text-2xl text-[#0A1F3D] leading-tight">
                                    {s.title}
                                </h3>
                                <p className="text-sm leading-relaxed text-neutral-600 flex-1">
                                    {s.description}
                                </p>
                                <div className="pt-4 border-t border-neutral-100 flex items-center justify-between text-xs text-neutral-500">
                                    <span>Müraciət et</span>
                                    <ArrowUpRight
                                        size={16}
                                        className="text-[#14545E] transition-transform group-hover:translate-x-1 group-hover:-translate-y-1"
                                    />
                                </div>
                            </div>
                        </Reveal>
                    ))}
                </div>

                {!standalone && (
                    <Reveal delay={0.2}>
                        <div className="mt-12 text-center">
                            <Link
                                to="/kurslar"
                                className="inline-flex items-center gap-2 text-[#14545E] hover:gap-3 transition-all text-sm"
                                data-testid="courses-see-all"
                            >
                                Bütün kurslara bax
                                <ArrowUpRight size={16} />
                            </Link>
                        </div>
                    </Reveal>
                )}
            </div>
        </section>
    );
};

export default Courses;
